import React from 'react';
import { Facebook, Instagram, Twitter, Youtube, Mail, MapPin, Phone, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-122">
          {/* Brand Column */}
          <div data-id="element-123">
            <h3 className="text-2xl font-bold mb-6 bg-gradient-to-r from-[#0066FF] to-[#06B6D4] bg-clip-text text-transparent" data-id="element-124">
              Himalayan Trekking
            </h3>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-125">
              Crafting unforgettable mountain experiences in Nepal, Tibet, and
              Bhutan since 2010. Your adventure begins here.
            </p>
            <div className="flex gap-4" data-id="element-126">
              {[Facebook, Instagram, Twitter, Youtube].map((Icon, i) => <a key={i} href="#" className="p-2 bg-gray-800 rounded-full hover:bg-[#0066FF] transition-colors" data-id="element-127">
                  <Icon size={18} data-id="element-128" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-129">
            <h4 className="text-lg font-semibold mb-6" data-id="element-130">Destinations</h4>
            <ul className="space-y-3 text-gray-400" data-id="element-131">
              {['Nepal Trekking', 'Bhutan Tours', 'Tibet Overland', 'Peak Climbing', 'Cultural Tours', 'Helicopter Tours'].map(item => <li key={item} data-id="element-132">
                  <a href="#" className="hover:text-[#06B6D4] transition-colors flex items-center gap-2" data-id="element-133">
                    <span className="w-1.5 h-1.5 bg-[#0066FF] rounded-full" data-id="element-134"></span>
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-135">
            <h4 className="text-lg font-semibold mb-6" data-id="element-136">Contact Us</h4>
            <ul className="space-y-4 text-gray-400" data-id="element-137">
              <li className="flex items-start gap-3" data-id="element-138">
                <MapPin className="text-[#0066FF] shrink-0 mt-1" size={20} data-id="element-139" />
                <span data-id="element-140">Thamel Marg, Kathmandu 44600, Nepal</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-141">
                <Phone className="text-[#0066FF] shrink-0" size={20} data-id="element-142" />
                <span data-id="element-143">+977 1-4422334</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-144">
                <Mail className="text-[#0066FF] shrink-0" size={20} data-id="element-145" />
                <span data-id="element-146">info@himalayantrekking.com</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-147">
            <h4 className="text-lg font-semibold mb-6" data-id="element-148">Newsletter</h4>
            <p className="text-gray-400 mb-4" data-id="element-149">
              Subscribe for latest updates and exclusive offers.
            </p>
            <form className="space-y-3" onSubmit={e => e.preventDefault()} data-id="element-150">
              <input type="email" placeholder="Your email address" className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-[#0066FF] text-white" data-id="element-151" />
              <Button variant="primary" className="w-full justify-center" data-id="element-152">
                Subscribe <ArrowRight size={16} className="ml-2" data-id="element-153" />
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-gray-500 text-sm" data-id="element-154">
          <p data-id="element-155">
            &copy; {new Date().getFullYear()} Himalayan Trekking. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-156">
            <a href="#privacy-policy" className="hover:text-white transition-colors" data-id="element-157">
              Privacy Policy
            </a>
            <a href="#terms-of-use" className="hover:text-white transition-colors" data-id="element-158">
              Terms of Service
            </a>
            <a href="#sitemap" className="hover:text-white transition-colors" data-id="element-159">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
}